// Getränkeland

// import amber from "@mui/material/colors/amber";
import green from "@mui/material/colors/orange";
import { createTheme } from "@mui/material/styles";

export default createTheme({
  paper: {
    // RMW  Test
    tertiary: {
      ///hausify hellgrau f2f2f2
      main: "#fff",
      text: "#000",
    },
  },
  palette: {
    primary: {
      ///hausify blau 00a2c7
      main: "#F5A623",
    },
    secondary: {
      ///hausify orange FCC332 (zb Head-Zeile Dropdown)
      // light
      // dark
      // FeSt Hausverwalt4
      main: "#F5A623",
      contrastText: "#fff",
    },
    notification: {
      ticketBadge: {
        // The number configures the shade
        main: green[500],
        text: "#fff",
      },
    },
    importNotification: {
      main: "#F5A623",
      text: "#fff",
    },
    ticketsNotification: {
      ///hausify orange FCC332 (zb Meine Verwaltung)
      main: "#F5A623",
      text: "#fff",
    },
    estateNotification: {
      ///hausify rosa e3cfde
      main: "#F5A623",
      contrastText: "#3B4145",
    },
    postingsNotification: {
      ///hausify blau 00a2c7
      main: "#F5A623",
      text: "#fff",
    },

    documentsNotification: {
      main: "#fff",
      contrastText: "#3B4145",
      text: "#3B4145",
    },
    explainerBox: {
      main: "#3B4145",
    },
  },
  typography: {
    fontFamily: ["roboto", "sans-serif", "serif"].join(","),
  },
});
